import 'css-chunksrc/client/common/filterMenu/projectPortfolios/styles.scss';export default {
  "header": "_header_q0pwa_1",
  "icon": "_icon_q0pwa_10",
  "title": "_title_q0pwa_18",
  "list": "_list_q0pwa_25"
};